<template>
  <v-select v-model="localValue" dense :items="items" :label="label" clearable outlined class="rounded-pill" :error-messages="errorMessages" :disabled="disabled" @input="clearError"  />
</template>

<script>
export default {
  name: 'SelectFilter',
  props: {
    value: {
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessages: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    clearError() {
      if (this.errorMessages) {
        this.$emit("clear-error");
      }
    },
  }
};
</script>
